import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import json2mq from "json2mq";
import {useNavigate} from "react-router-dom";

const PromoBanner = () => {
    const navigate = useNavigate();
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const styles = {
        banner: {
            padding: "6px 10px 7px 6px",
            display: "flex",
            alignItems: "center",
            borderRadius: "18px",
            background: "linear-gradient(90deg, rgba(24, 119, 242, 0.30) 0.02%, rgba(24, 119, 242, 0.00) 123.27%)",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 2px 0px rgba(0, 0, 0, 0.20)",
            color: "#000",
            fontFamily: "Inter, sans-serif",
            flexWrap: "wrap",
            width: "99.5%",
            margin: "2px auto",
            boxSizing: "border-box",
            justifyContent: "flex-start",
            gap: mediaQueryVar ? "20%" : "0",
            cursor: "pointer",
        },
        icon: {
            width: mediaQueryVar ? "45px" : "35px",
            height: mediaQueryVar ? "45px" : "35px",
            marginRight: mediaQueryVar ? "10px" : "5px",
            marginLeft: mediaQueryVar ? "30px" : "0px",
        },
        textContainer: {
            display: "flex",
            flexDirection: "column",
            lineHeight: mediaQueryVar ? "28px" : "22px",
            alignItems: "center",
            textAlign: "center",
            width: mediaQueryVar ? "" : "300px",
        },
        subtitle: {
            fontWeight: "700",
            fontSize: mediaQueryVar ? "14px" : "11px",
            width: "100%",
            minHeight: "40px",
            userSelect: "none",  
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",  
        },
    };

    const handleClick = () => {
        navigate("/subscriptions");
    };

    return (
        <div style={styles.banner} onClick={handleClick}>
            <img
                rel="preload"
                src={`${window.constants.asset_path}/images/noto_fire.svg`}
                alt="Fire"
                style={styles.icon}
            />
            <div style={styles.textContainer}>
                <div style={styles.subtitle}>
                    {" "}
                    Stop Guessing, Start Profiting. 2X gains last month — lock it in now for $1/month.
                </div>
            </div>
        </div>
    );
};

export default PromoBanner;
